import AppContextProvider from 'contexts/AppContext';
import AuthContextProvider from 'contexts/AuthContext';
import DialogManagerContextProvider from 'contexts/DialogManagerContext';
import EntityContextProvider from 'contexts/EntityContext';
import ReactDOM from 'react-dom/client';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AuthContextProvider>
    <AppContextProvider>
      <EntityContextProvider>
        <DialogManagerContextProvider>
          <App />
        </DialogManagerContextProvider>
      </EntityContextProvider>
    </AppContextProvider>
  </AuthContextProvider>,
);
